import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon,
  editRiskTypeDialog,
} from 'app/components/global';
import editRiskDialog from '../dialog.editRiskDialog';
import deleteRiskTypeConfirmDialog from '../dialog.deleteRiskTypeConfirmDialog';
import controller from './risk-type.controller';
import directive from './risk-type.directive';

const riskModule = angular.module('app.components.admin.riskAdmin.riskType', [
  alerts,
  actionIcon,
  confirmDialog,
  editRiskDialog,
  loaderService,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
  editRiskTypeDialog,
  deleteRiskTypeConfirmDialog,
])
  .directive('riskType', directive)
  .controller('RiskTypeController', controller);

export default riskModule.name;

console.log('app.components.admin.riskAdmin.riskType created');
